<template>
  <div class="currency-balance">
    <Form :model="searchCondition" :label-width="70" inline>
      <FormItem label="手机号">
        <Input
          v-model="searchCondition.mobile"
          placeholder="请输入买家手机号"
          style="width:200px"
          clearable
        ></Input>
      </FormItem>
      <FormItem class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="onSearch">搜索</Button>
          <Button icon="md-undo" @click="onReset">重置</Button>
        </div>
      </FormItem>
    </Form>
    <div class="content">
      <Grid
        ref="grid"
        :columns="tableColumns"
        data-url="/api/balance/user"
        :search="searchCondition"
        :rowsFormatter="onrowsFormatter"
        selectType
        keyField="order_number"
        method="get"
      >
        <template slot-scope="{row}" slot="action">
          <Button type="text" @click="onDetail(row)">查看明细 - </Button>
          <Button type="text" @click="handleEdit(row)">修改金币</Button>
        </template>
      </Grid>
    </div>

    <Modal title="修改金币" v-model="editGoldModal">
      <Form ref="form" :model="formInfo" :rules="rules" :label-width="100">
        <FormItem label="当前金币">{{ formInfo.integral }}</FormItem>
        <FormItem label="金币变化" prop="change_price">
          <InputNumber
            style="width:120px"
            :min="0 - formInfo.integral"
            v-model="formInfo.change_price"
            placeholder="-1表示减去1金币"
          />金币
          <span class="tag" style="color:#999;">
            <Icon type="ios-alert" size="15" color="#f7cb4b" />-1表示减去1金币
          </span>
        </FormItem>
        <FormItem label="修改缘由" prop="remark">
          <Input
            v-model="formInfo.remark"
            placeholder="请输入修改缘由，最多16个字"
            :maxlength="16"
            style="width:200px"
            clearable
          ></Input>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button @click="editGoldModal = false">取消</Button>
        <Button type="primary" @click="handleSave">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "currency-balance",
  data() {
    return {
      editGoldModal: false,
      rules: {
        change_price: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("价格不能为空"));
              } else {
                callback();
              }
            }
          }
        ],
        remark: [{ required: true, message: "请输入" }]
      },

      formInfo: {
        integral: 0,
        change_price: 0,
        remark: ""
      },
      searchCondition: {
        mobile: "",
        init() {
          this.mobile = "";
        }
      },
      tableColumns: [
        { title: "用户名称", key: "nickname", minWidth: 200 },
        { title: "用户手机号", key: "mobile", align: "center", minWidth: 120 },
        { title: "余额", key: "integral", align: "center", minWidth: 170 },
        {
          title: "操作",
          slot: "action",
          align: "center",
          minWidth: 120,
          fixed: "right"
        }
      ]
    };
  },
  methods: {
    // on event
    onSearch() {
      this.$refs.grid.searchRefresh();
    },
    onReset() {
      this.searchCondition.init();
      this.$refs.grid.searchRefresh();
    },
    onrowsFormatter(rows) {
      rows.forEach(i => {
        i.integral = this.$pub.calcPrice(i.integral);
      });
    },
    onDetail(row) {
      this.$router.push({
        name: "VCurrencyDetail",
        query: {
          user_id: row.user_id,
          nickname: row.nickname,
          mobile: row.mobile,
          remaining_sum: row.integral
        }
      });
    },
    //修改金币弹框
    handleEdit(row) {
      this.formInfo.user_id = row.user_id;
      this.formInfo.integral = row.integral;
      // this.formInfo = row
      this.formInfo.change_price = 0;
      this.formInfo.remark = "";
      this.editGoldModal = true;
    },
    //保存金币修改
    handleSave() {
      this.$refs.form.validate(valid => {
        if (!valid) return;
        this.$http
          .put(`/api/balance/${this.formInfo.user_id}`, {
            change_price: this.formInfo.change_price,
            remark: this.formInfo.remark
          })
          .then(() => {
            this.$Message.success("操作成功");
            this.editGoldModal = false;
            this.$refs.grid.searchRefresh();
          });
      });
    },
  }
};
</script>

<style lang="scss" scoped>
</style>
